import { RouteType } from "../@types/RouteType";
import { DashboardRoutes, WarrantyClaimRoutes, TechSupportRoutes, ResourcesRoutes, GeneralRoutes } from "./MainRoutes";

const DealerServiceRoutes: RouteType[] = [
    ...DashboardRoutes,
    ...WarrantyClaimRoutes,
    ...TechSupportRoutes,
    ...ResourcesRoutes,
    ...GeneralRoutes
]

export default DealerServiceRoutes;